<template>

  <div class="register">
    <div class="lucky">
      <div class="goBack"><img src="../assets/images/fanhui2.png" @click="$router.go(-1)" class="goBackBtns"></div>
      <div class="titles">重置密码</div>
    </div>
    <div class="container">
      <ul class="panel inputGroup">
        <li>
          <span class="icon-phone icon"></span>
          <input type="text" placeholder="请输入手机号" v-model="phonenumber" @blur="testMobile">
        </li>
        <!-- <li>
            <span class="icon-ma icon"></span>
            <input type="text" placeholder="图形验证码" class="" v-model="pwd">
            <span class="get_pwd">2y25ag</span>
        </li> -->
        <li>
          <span class="icon-ma icon"></span>
          <input type="text" placeholder="请输入验证码" class="" v-model='code'>
          <span class="get_pwd" @click="get_pwd()">{{ this.intervalText }}</span>
        </li>
        <li>
          <span class="icon-pwd icon"></span>
          <input type="password" placeholder="请输入密码" class="" v-model="password">
        </li>
        <li>
          <span class="icon-pwd icon"></span>
          <input type="password" placeholder="请再次输入密码" class="" v-model="password2" @blur="confirmPwd">
        </li>
      </ul>
      <div class="btn_group">
        <mt-button size="large" class="btn-orange" @click="submit">提交</mt-button>
      </div>
    </div>
    <v-tip></v-tip>
  </div>
</template>
<script>
import tip from './tip/tip'
import {Toast} from 'mint-ui';

export default {
  name: 'login',
  data() {
    return {
      intervalText: '发送验证码',
      timer: null,
      phonenumber: null,
      code: null,
      pwd: null,
      password: null,
      password2: null,
    }
  },
  mounted() {
    var something = this.$el.outerHTML;
  },
  components: {
    'vTip': tip,
  },
  methods: {
    get_pwd() {
      if (!this.timer) {
        var time = 60;
        this.intervalText = time + '秒后重新获取';
        this.timer = setInterval(() => {
          time--;
          this.intervalText = time + '秒后重新获取';
          if (time <= 0) {
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);

        let params = {};
        params.phonenumber = String(this.phonenumber);
        params.type = "PASSWORD";
        this.Api.sendSms(params)
      }

    },
    testMobile() {
      let phonenumber = this.phonenumber;
      let reg = /^1[34578]\d{9}$/;
      if (!reg.test(phonenumber)) {
        Toast('请输入正确的手机号');
        this.phonenumber = null;
        return false;
      }
    },
    confirmPwd() {
      if (this.password2 !== this.password) {
        Toast('两次密码输入不一致');
        this.password2 = null;
        return false;
      }
    },
    submit() {
      if (!this.phonenumber) {
        Toast('请填写手机号');
        return false;
      }
      if (!this.code) {
        Toast('请输入验证码');
        return false;
      }
      if (!this.password) {
        Toast('请收入密码');
        return false;
      }
      if (!this.password2) {
        Toast('请再次输入密码');
        return false;
      }
      var params = {};
      params.username = this.phonenumber;
      params.password = this.password;
      params.code = this.code;
      this.Api.resetPassword(params, (msg) => {
        if (msg.code === 200) {
          this.$router.push({
            path: '/',
          });
          localStorage.setItem('token', msg.token);
          this.Api.saveInfo();
        }
        if (msg.code === 402) {
          Toast('密码错误');
          return false;
        }
      })
    }
  }
}
</script>
<style scoped>
@import url('./login.css');

.lucky {
  position: relative;
  text-align: center;
  width: 100%;
  line-height: 44px;
  top: 0;
  z-index: 100;
  background-color: transparent;
  border: none;
}

.titles {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  font-size: 16px;
  display: inline-block;
  line-height: 44px;
  text-align: center;
  color: #FFFFFF;
}

.goBack {
  width: 44px;
  height: 44px;
  text-align: center;
  line-height: 44px;
}

.goBackBtns {
  width: 22px;
  height: 22px;
  vertical-align: middle;
}
</style>




// WEBPACK FOOTER //
// src/components/forget.vue